import { AppointmentConfigs } from "@elixir/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { putUpdateAPackage } from "apis";
import { getQueueConfigQueryKey } from "../get-queue-config";
import { TrystGenericResponse } from "../types";
import { useMyAccessProfileV2 } from "../get-my-access-profile";

const useUpdateAPackage = () => {
  const queryClient = useQueryClient();

  const { data: myAccessProfile } = useMyAccessProfileV2();

  return useMutation(putUpdateAPackage, {
    onMutate: ({ data }) => {
      const packageId = data.package_id;
      queryClient.setQueryData<TrystGenericResponse<AppointmentConfigs>>(
        getQueueConfigQueryKey({ businessId: myAccessProfile?.business?.id }),
        (currQueueConfig) => {
          if (currQueueConfig?.data) {
            const { packages } = currQueueConfig.data;
            const updatedPackageList = packages?.map((pkg) => {
              if (pkg.package_id === packageId) {
                return { ...pkg, ...data };
              }
              return pkg;
            });
            return {
              ...currQueueConfig,
              data: {
                ...currQueueConfig.data,
                packages: updatedPackageList,
              },
            };
          }
          return currQueueConfig;
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(getQueueConfigQueryKey());
      return;
    },
  });
};

export default useUpdateAPackage;
